import * as React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useRecordContext } from "react-admin";
import { VIDHI_ADMIN_URL } from "../../Routes";
import DownloadJobDescriptionButton from "./download-job-description-button";

const FieldRow = ({ label, children }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="subtitle2"
      color="textSecondary"
      sx={{ fontSize: "12px", marginBottom: "4px" }}
    >
      {label}
    </Typography>
    {children}
  </Box>
);

const VidhiAssessmentTable = ({ title, assessments }) => {
  if (!assessments?.length) {
    return (
      <Typography variant="body2" sx={{ mb: 2 }}>
        No {title.toLowerCase()}
      </Typography>
    );
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Level</TableCell>
            <TableCell>Weight</TableCell>
            <TableCell>Rank</TableCell>
            <TableCell>Suggested Critical</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {assessments.map((assessment, index) => (
            <TableRow key={`${assessment.name}-${index}`}>
              <TableCell>{assessment.name}</TableCell>
              <TableCell>{assessment.type}</TableCell>
              <TableCell>{assessment.level}</TableCell>
              <TableCell>{assessment.weight}</TableCell>
              <TableCell>{assessment.rank}</TableCell>
              <TableCell>{assessment.suggestedCritical ? "Yes" : "No"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export const JobDescriptionTab = () => {
  const record = useRecordContext();
  const jobDescription = record?.jobDescription;

  if (!jobDescription) {
    return (
      <Typography variant="body2">No job description for this campaign.</Typography>
    );
  }

  const recommendations = jobDescription.recommendations;
  const result = recommendations?.result;

  return (
    <Box>
      <FieldRow label="Title">
        <Typography variant="body2">{jobDescription.title || "-"}</Typography>
      </FieldRow>

      <FieldRow label="Description">
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
          {jobDescription.description || "-"}
        </Typography>
      </FieldRow>

      <FieldRow label="Document">
        <DownloadJobDescriptionButton url={jobDescription.url} />
      </FieldRow>

      {recommendations && (
        <>
          <FieldRow label="Vidhi Session ID">
            <Typography variant="body2">
              {recommendations.sessionId ? (
                <a
                  href={`${VIDHI_ADMIN_URL}/sessions/${recommendations.sessionId}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {recommendations.sessionId}
                </a>
              ) : (
                "-"
              )}
            </Typography>
          </FieldRow>

          {result && (
            <>
              <FieldRow label="Recommended Role Title">
                <Typography variant="body2">{result.title || "-"}</Typography>
              </FieldRow>
              <FieldRow label="Company">
                <Typography variant="body2">{result.company || "-"}</Typography>
              </FieldRow>
              <FieldRow label="Department">
                <Typography variant="body2">{result.department || "-"}</Typography>
              </FieldRow>

              <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 1 }}>
                Vidhi Response
              </Typography>

              <VidhiAssessmentTable title="Abilities" assessments={result.abilities} />
              <VidhiAssessmentTable title="Traits" assessments={result.traits} />
            </>
          )}
        </>
      )}
    </Box>
  );
};
